import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";
import {
  DataVendorCostAllocationRequest,
  DataVendorCostAllocationResponse,
  DataVendorDto,
} from "interfaces/Mueller.Business.Models";

export const getDataVendors = (successCallback: (response: DataVendorDto[]) => void, mountedRef) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/data-vendor/list`,
    successCallback,
    mountedRef,
  });

export const allocateCosts = (
  invoice: DataVendorCostAllocationRequest,
  successCallback: (response: DataVendorCostAllocationResponse) => void,
  errorCallback: () => void, 
  mountedRef
) =>
  WebApiRequest({
    method: HTTP_POST,
    endpoint: `/data-vendor/allocate-cost`,
    payload: invoice,
    successCallback,
    errorCallback,
    mountedRef,
  });
